"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PromotionOverviewDTO_1 = require("../../promotion/model/PromotionOverviewDTO");

var PromotionOverviewDTOConverter_1 = require("./PromotionOverviewDTOConverter");
/**
 * @author PKr
 */


var PromotionOverviewDTOConverterImpl =
/*#__PURE__*/
function (_PromotionOverviewDTO) {
  _inherits(PromotionOverviewDTOConverterImpl, _PromotionOverviewDTO);

  function PromotionOverviewDTOConverterImpl() {
    _classCallCheck(this, PromotionOverviewDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionOverviewDTOConverterImpl).apply(this, arguments));
  }

  _createClass(PromotionOverviewDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new PromotionOverviewDTO_1.PromotionOverviewDTO(PromotionOverviewDTO_1.PromotionOverviewDTO.schema.id.valueOf(conversions.documentToClassId(source)), PromotionOverviewDTO_1.PromotionOverviewDTO.schema.totalWindowCount.valueOfField(source), PromotionOverviewDTO_1.PromotionOverviewDTO.schema.rejectedCDWindowCount.valueOfField(source), PromotionOverviewDTO_1.PromotionOverviewDTO.schema.rejectedPMWindowCount.valueOfField(source), PromotionOverviewDTO_1.PromotionOverviewDTO.schema.preparedWindowCount.valueOfField(source), PromotionOverviewDTO_1.PromotionOverviewDTO.schema.conceptWindowCount.valueOfField(source), PromotionOverviewDTO_1.PromotionOverviewDTO.schema.approvedWindowCount.valueOfField(source), PromotionOverviewDTO_1.PromotionOverviewDTO.schema.changedWindowCount.valueOfField(source), PromotionOverviewDTO_1.PromotionOverviewDTO.schema.windowItemsCount.valueOfField(source), PromotionOverviewDTO_1.PromotionOverviewDTO.schema.locked.valueOfField(source), PromotionOverviewDTO_1.PromotionOverviewDTO.schema.fcApprovalNeeded.valueOfField(source), PromotionOverviewDTO_1.PromotionOverviewDTO.schema.lockedForCurrentUser.valueOfField(source), PromotionOverviewDTO_1.PromotionOverviewDTO.schema.haveSimulations.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        totalWindowCount: source.totalWindowCount,
        rejectedCDWindowCount: source.rejectedCDWindowCount,
        rejectedPMWindowCount: source.rejectedPMWindowCount,
        preparedWindowCount: source.preparedWindowCount,
        conceptWindowCount: source.conceptWindowCount,
        approvedWindowCount: source.approvedWindowCount,
        changedWindowCount: source.changedWindowCount,
        windowItemsCount: source.windowItemsCount,
        fcApprovalNeeded: source.fcApprovalNeeded,
        locked: source.locked,
        lockedForCurrentUser: source.lockedForCurrentUser,
        haveSimulations: source.haveSimulations
      });
      return result;
    }
  }]);

  return PromotionOverviewDTOConverterImpl;
}(PromotionOverviewDTOConverter_1.PromotionOverviewDTOConverter);

exports.PromotionOverviewDTOConverterImpl = PromotionOverviewDTOConverterImpl;